<template>
    <div class="energy-efficiency-card">
        <div class="left-section">
            <div class="card-container">
                <!-- 인증등급 카드 -->
                <div class="grade-card certified" :style="{ borderTopColor: getGradeColor(certifiedGrade) }">
                    <div class="card-title">인증등급</div>
                    <div
                        class="card-grade font-roboto-slab"
                        :style="{ backgroundColor: getGradeColor(certifiedGrade), color: 'white' }"
                    >
                        {{ certifiedGrade || "-" }}
                    </div>
                    <div class="card-criteria">{{ getGradeCriteria(certifiedGrade) }}</div>
                </div>

                <!-- 운영등급(전체) 카드 -->
                <div class="grade-card total-operating" :style="{ borderTopColor: getGradeColor(totalOperatingGrade) }">
                    <div class="card-title">전체등급</div>
                    <div
                        class="card-grade font-roboto-slab"
                        :style="{ backgroundColor: getGradeColor(totalOperatingGrade), color: 'white' }"
                    >
                        {{ totalOperatingGrade || "-" }}
                    </div>
                    <div class="card-criteria">{{ getGradeCriteria(totalOperatingGrade) }}</div>
                </div>

                <!-- 운영등급 카드 -->
                <div class="grade-card operating" :style="{ borderTopColor: getGradeColor(measuredGrade) }">
                    <div class="card-title">당월등급</div>
                    <div
                        class="card-grade font-roboto-slab"
                        :style="{ backgroundColor: getGradeColor(measuredGrade), color: 'white' }"
                    >
                        {{ measuredGrade || "-" }}
                    </div>
                    <div class="card-criteria">{{ getGradeCriteria(measuredGrade) }}</div>
                </div>
            </div>
        </div>

        <div class="right-section">
            <div class="stack-chart">
                <div
                    v-for="(grade, index) in gradeData"
                    :key="`grade-${index}`"
                    class="grade-bar"
                    :style="{
                        backgroundColor: colorGradient[index],
                        height: `${grade.value}%`,
                    }"
                >
                    <span v-if="grade.showLabel" class="grade-label">{{ grade.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "xeEnergyEfficiencyCard",
    props: {
        rawData: {
            type: Object,
            default: null,
        },
        cardHeight: {
            type: Number,
            default: 1,
        },
        cardWidth: {
            type: Number,
            default: 1,
        },
        widget: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            gradeData: [
                { label: "1+++", value: 10, showLabel: true },
                { label: "1++", value: 10, showLabel: true },
                { label: "1+", value: 10, showLabel: true },
                { label: "1", value: 10, showLabel: true },
                { label: "2", value: 10, showLabel: true },
                { label: "3", value: 10, showLabel: true },
                { label: "4", value: 10, showLabel: true },
                { label: "5", value: 10, showLabel: true },
                { label: "6", value: 10, showLabel: true },
                { label: "7", value: 10, showLabel: true },
            ],
            colorGradient: [
                "#4caf50",
                "#7cb342",
                "#cddc39",
                "#ffeb3b",
                "#ffc107",
                "#ff9800",
                "#ff7043",
                "#ff5722",
                "#f44336",
                "#d32f2f",
            ],
            energyGrades: [
                { grade: "1+++", maxConsumption: 80 },
                { grade: "1++", maxConsumption: 140 },
                { grade: "1+", maxConsumption: 200 },
                { grade: "1", maxConsumption: 260 },
                { grade: "2", maxConsumption: 320 },
                { grade: "3", maxConsumption: 380 },
                { grade: "4", maxConsumption: 450 },
                { grade: "5", maxConsumption: 520 },
                { grade: "6", maxConsumption: 610 },
                { grade: "7", maxConsumption: 700 },
            ],
        };
    },
    computed: {
        measuredGrade() {
            return this.rawData?.values?.grade?.measuredGrade;
        },
        certifiedGrade() {
            return this.rawData?.values?.grade?.certifiedGrade;
        },
        totalOperatingGrade() {
            return this.rawData?.values?.grade?.totalOperatingGrade;
        },
    },
    methods: {
        getGradeCriteria(grade) {
            if (!grade) return "-";

            const gradeInfo = this.energyGrades.find((g) => g.grade === grade);
            if (!gradeInfo) return "-";

            return `${gradeInfo.maxConsumption} kWh/㎡·yr 이하`;
        },
        getGradeColor(grade) {
            if (!grade) return "#6c757d";

            const gradeIndex = this.gradeData.findIndex((g) => g.label === grade);
            if (gradeIndex === -1) return "#6c757d";

            return this.colorGradient[gradeIndex];
        },
    },
};
</script>

<style scoped>
.energy-efficiency-card {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 16px;
}

.left-section {
    width: 80%;
    display: flex;
    flex-direction: column;
}

.card-container {
    display: flex;
    flex-direction: row;
    gap: 12px;
    height: 100%;
    align-items: center;
}

.grade-card {
    flex: 1;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    height: 80%;
}

.grade-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.card-title {
    flex: 1;
    font-size: 12px;
    font-weight: 600;
    color: #6c757d;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.card-grade {
    flex: 1;
    font-size: 24px;
    font-weight: 800;
    color: #212529;
    text-align: center;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-criteria {
    flex: 1;
    font-size: 10px;
    color: #868e96;
    text-align: center;
    line-height: 1.3;
    display: flex;
    align-items: center;
    justify-content: center;
}

.right-section {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stack-chart {
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    gap: 1px;
    padding: 8px;
}

.grade-bar {
    position: relative;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 12px;
    transition: all 0.3s ease;
}

.grade-bar:hover {
    transform: scaleX(1.05);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.grade-label {
    font-size: 10px;
    font-weight: 600;
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 등급별 특별 스타일 */
.grade-card.certified {
    border-top: 4px solid;
}

.grade-card.total-operating {
    border-top: 4px solid;
}

.grade-card.operating {
    border-top: 4px solid;
}
</style>
